let b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', a256 = '', r64 = [256], r256 = [256], i = 0

function encode(strUni) {
  let strUtf = strUni.replace(/[\u0080-\u07ff]/g, function(c) {
    let cc = c.charCodeAt(0)
    return String.fromCharCode(0xc0 | cc >> 6, 0x80 | cc & 0x3f)
  }).replace(/[\u0800-\uffff]/g, function(c) {
    let cc = c.charCodeAt(0)
    return String.fromCharCode(0xe0 | cc >> 12, 0x80 | cc >> 6 & 0x3F, 0x80 | cc & 0x3f)
  })
  return strUtf
}

function decode(strUtf) {
  let strUni = strUtf.replace(/[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g, function(c) {
    let cc = ((c.charCodeAt(0) & 0x0f) << 12) | ((c.charCodeAt(1) & 0x3f) << 6) | (c.charCodeAt(2) & 0x3f)
    return String.fromCharCode(cc)
  }).replace(/[\u00c0-\u00df][\u0080-\u00bf]/g, function(c) {
    let cc = (c.charCodeAt(0) & 0x1f) << 6 | c.charCodeAt(1) & 0x3f
    return String.fromCharCode(cc)
  })
  return strUni
}

while(i < 256) {
  let c = String.fromCharCode(i)
  a256 += c
  r256[i] = i
  r64[i] = b64.indexOf(c)
  ++i
}

function code(s, discard, alpha, beta, w1, w2) {
  s = String(s)
  let buffer = 0, i = 0, length = s.length, result = '', bitsInBuffer = 0
  while(i < length) {
    let c = s.charCodeAt(i)
    c = c < 256 ? alpha[c] : -1

    buffer = (buffer << w1) + c
    bitsInBuffer += w1

    while(bitsInBuffer >= w2) {
      bitsInBuffer -= w2
      let tmp = buffer >> bitsInBuffer
      result += beta.charAt(tmp)
      buffer ^= tmp << bitsInBuffer
    }
    ++i
  }
  if(!discard && bitsInBuffer > 0) result += beta.charAt(buffer << (w2 - bitsInBuffer))
  return result
}

function utf8base64btoa(plain) {
  plain = encode(plain)
  plain = code(plain, false, r256, b64, 8, 6)
  return plain + '===='.slice((plain.length % 4) || 4)
}

function utf8base64atob(coded) {
  coded = String(coded).split('=')
  let i = coded.length
  do {
    --i
    coded[i] = code(coded[i], true, r64, a256, 6, 8)
  } while (i > 0)
  coded = coded.join('')
  return decode(coded)
}

export {
  utf8base64btoa,
  utf8base64atob,
}
